const state = {
  tableOrder: {},
  newOrder: {},
  modalAssignWaiter: false,
  tables: []
};
export default state;


